import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleMaintenanceComponent } from './role-maintenance.component';

const routes: Routes = [
  {
    path:'',
    component: RoleMaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RoleMaintenanceRoutingModule { }
